<template>
  <vis-map class="vis-public-map" :no-auth="true"></vis-map>
</template>

<script>
import VisMap from "./vis-map";

export default {
  name: "vis-public-map",
  components: { VisMap },
  created() {
    document.documentElement.classList.add('vis-theme')
  },
  destroyed() {
    document.documentElement.classList.remove('vis-theme')
  }
};
</script>
